import { applySearchQueries, QueryBuilder } from "./Helpers";
export const SearchConnection = {
    search(q) {
        return applySearchQueries(QueryBuilder.search(q));
    },
    personalizedEvents(q) {
        return applySearchQueries(QueryBuilder.personalizedEvents(q));
    }
};
//# sourceMappingURL=SearchConnection.js.map